import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async finalisar ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `analise/dae`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/analiseDae.js